<template>
    <div class="headache-item">
        <p>
            {{item.beginDate}}
            <button
             class="del"
             @click="$emit('del-item', item.id)"
             >x</button>
        </p> 
    </div>
</template>

<script>

export default {
    name: "HeadacheItem",
    props: ["item"],
}

</script>

<style scoped>

.headache-item {
    background: #f4f4f4;
    padding: 10px;
    border-bottom: 1px #ccc dotted;
}

.del {
    background: #ff0000;
    color: #fff;
    border: none;
    padding: 5px 9px;
    border-radius: 50%;
    cursor: pointer;
    float: right;
}

</style>
